import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  background: #fff;
`;

export const Page = styled.section`
  overflow-x: hidden;
`;

export const Differentials = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 2rem;
  padding: 4rem 1rem;

  @media (min-width: 1024px) {
    flex-direction: row;
    gap: 0;
    padding: 4rem 2rem 4rem 2rem;
    padding-right: 0;
  }

  @media (min-width: 1536px) {
    padding-left: 8rem;
  }
`;

export const DiffLeft = styled.div`
  h3 {
    font-size: 1.5rem;
    font-weight: 600;
    line-height: 1.25;
    color: var(--color-secondary);
    text-align: center;

    b {
      font-weight: 700;
    }

    @media (min-width: 1024px) {
      text-align: left;
    }

    @media (min-width: 1280px) {
      font-size: 1.875rem;
    }

    @media (min-width: 1536px) {
      font-size: 2.5rem;
    }
  }
`;

export const DiffTitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding-top: 2rem;
  color: var(--color-secondary);

  svg,
  img {
    width: 20px;
    height: auto;
    flex-shrink: 0;
  }

  h4 {
    font-size: 1.125rem;
    font-weight: 600;
  }

  @media (min-width: 1024px) {
    justify-content: flex-start;
  }

  @media (min-width: 1280px) {
    h4 {
      font-size: 1.25rem;
    }
    svg,
    img {
      width: 25px;
    }
  }

  @media (min-width: 1536px) {
    h4 {
      font-size: 1.5rem;
    }
    svg,
    img {
      width: 35px;
    }
  }
`;

export const DiffText = styled.p`
  font-size: 1.125rem;
  font-weight: 500;
  color: var(--color-secondary);
  padding-top: 0.5rem;
  text-align: center;

  @media (min-width: 1024px) {
    max-width: 400px;
    text-align: left;
  }

  @media (min-width: 1280px) {
    max-width: 500px;
    font-size: 1.25rem;
  }

  @media (min-width: 1536px) {
    max-width: 800px;
    font-size: 1.5rem;
  }
`;

export const DiffRight = styled.div`
  width: 100%;
  background: var(--color-primary);
  border-radius: 60px;
  padding: 2rem;

  @media (min-width: 1024px) {
    width: 500px;
    border-radius: 80px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    padding: 2rem 4rem;
  }

  @media (min-width: 1280px) {
    width: 600px;
  }

  @media (min-width: 1536px) {
    width: 700px;
  }

  ${DiffTitleRow} {
    color: #fff;
    padding-top: 0;
  }

  ${DiffText} {
    color: #fff;
    padding-top: 1rem;
    max-width: none;
  }
`;

export const SectionPad = styled.div`
  padding-inline: 1rem;
  overflow: visible;

  @media (min-width: 1024px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  @media (min-width: 1536px) {
    padding-left: 8rem;
    padding-right: 8rem;
  }
`;

export const SectionPadTall = styled(SectionPad)`
  padding-block: 2rem;
`;

export const SectionPadBottom = styled(SectionPad)`
  padding-top: 2rem;
  padding-bottom: 4rem;
`;

export const SectionHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;

  h4 {
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--color-secondary);
    text-align: center;

    @media (min-width: 1024px) {
      text-align: left;
    }

    @media (min-width: 1280px) {
      font-size: 1.25rem;
    }

    @media (min-width: 1536px) {
      font-size: 1.5rem;
    }
  }

  p {
    font-size: 0.75rem;
    color: var(--color-secondary);
    text-align: center;

    @media (min-width: 1024px) {
      text-align: left;
    }

    @media (min-width: 1280px) {
      font-size: 0.875rem;
    }

    @media (min-width: 1536px) {
      font-size: 1rem;
    }
  }
`;

export const TitleWithIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: var(--color-secondary);

  @media (min-width: 1024px) {
    justify-content: flex-start;
  }

  svg,
  img {
    width: 15px;
    height: auto;

    @media (min-width: 1280px) {
      width: 20px;
    }

    @media (min-width: 1536px) {
      width: 25px;
    }
  }
`;

export const DualHighlight = styled.div`
  width: 100%;
  height: 450px;
  background: var(--color-surface);
  transition: transform 0.3s ease;
  cursor: pointer;
  border-radius: 1rem;
  overflow: hidden;

  &:hover {
    transform: scale(1.05);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 1rem;
  }

  @media (min-width: 1280px) {
    height: 550px;
  }

  @media (min-width: 1536px) {
    height: 650px;
  }
`;
